import React from 'react';
import { Platform, Keyboard, Pressable, PressableProps, View } from 'react-native';
import useStyles from '../../hooks/styles-hook';

export interface OverlayProps extends PressableProps {
  showOverLay: boolean;
  zIndex: number;
  children?: any;
  dimBackground?: boolean;
  allowBackgroundInteraction?: boolean;
  contentContainerStyle?: any;
}

const Overlay = (props: OverlayProps) => {
  const styles = useStyles((section) => section.overlay);

  const handleClick = (event) => {
    if (Platform.OS !== 'web') {
      Keyboard.dismiss();
    }

    if (event?.target !== undefined && event?.currentTarget !== undefined && event.target !== event.currentTarget) {
      return;
    }

    props.onPress && props.onPress(event);
  };

  return (
    <View
      pointerEvents={props.allowBackgroundInteraction ? 'box-none' : 'auto'}
      style={[{ zIndex: props.zIndex, display: props.showOverLay ? 'flex' : 'none' }, styles.container]}
    >
      {!props.allowBackgroundInteraction && (
        <Pressable
          style={[styles.overlay, props.dimBackground === false ? { backgroundColor: 'transparent' } : undefined]}
          onPress={handleClick}
        ></Pressable>
      )}
      <View
        pointerEvents="box-none"
        style={[
          {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1,
            justifyContent: 'center' as any,
            alignItems: 'center' as any,
          },
          props.contentContainerStyle,
        ]}
      >
        {props.children}
      </View>
    </View>
  );
};

export default Overlay;
